/**
 * External dependencies.
 */
import { __ } from '@wordpress/i18n';
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import {
	PanelBody,
	ToggleControl,
	Notice,
} from '@wordpress/components';

export default ( { attributes: { responsivesidenavigation }, setAttributes } ) => {
	const blockProps = useBlockProps( {
		style: {
			fontFamily: 'var(--portal-font-family)',
		},
		className: 'suredash-portal__editor-title portal-content',
	} );

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<ToggleControl
						label={ __( 'Responsive: Aside Navigation Trigger', 'suredash' ) }
						checked={ responsivesidenavigation }
						onChange={ ( responsivesidenavigation ) => setAttributes( { responsivesidenavigation } ) } // eslint-disable-line
					/>
					<Notice status="warning" className="spectra-sidebar-settings-notice" isDismissible={ false }>
						{ __( 'In responsive mode, the side navigation trigger appears aside to Title block.', 'suredash' ) }
						<br />
						<br />
						{ __( 'You also have other option to keep is aside of Identity block.', 'suredash' ) }
					</Notice>
				</PanelBody>
			</InspectorControls>

			<h1 { ...blockProps }>
				{ __( 'Welcome User!', 'suredash' ) }
			</h1>
		</>
	);
};
